import clsx from "clsx";
import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";

import { cn, getSchemaMaxLength } from "common/helpers/utils";
import { InmailTemplateSchema } from "common/schemas";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  characterLength: number;
  errorMessage: string;
}

function TemplateSubjectInput(
  { className, errorMessage, characterLength, ...props }: InputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const maxLength = getSchemaMaxLength(InmailTemplateSchema.entries.subject);

  return (
    <div className={cn("group lg:mb-2 px-2 pt-5 lg:pt-2", className)}>
      <label
        htmlFor="templateSubject"
        className="mb-0.5 ml-1 text-button-xxs text-black-500 transition-[color] group-has-[:disabled]:text-black-500 group-has-[:focus]:text-purple-500"
      >
        Subject
      </label>

      <div
        className={clsx(
          "flex items-center gap-x-2 border-b border-b-black-200 px-1 pb-1.5 transition-colors group-has-[:disabled]:text-black-500",
          errorMessage
            ? "group-has-[:focus]:border-red-400"
            : "group-has-[:focus]:border-purple-400",
        )}
      >
        <input
          id="templateSubject"
          name="templateSubject"
          className="w-full bg-transparent text-md lg:text-sm outline-none placeholder:text-black-500"
          ref={ref}
          placeholder="Write subject here"
          {...props}
        />

        <span
          className={clsx(
            "text-xs transition-[color]",
            characterLength > maxLength ? "text-red-500" : "text-black-500",
          )}
        >
          {characterLength}/{maxLength}
        </span>
      </div>

      {/* Error message */}
      {errorMessage && (
        <span className="mt-1 inline-flex text-xs text-red-500">
          {errorMessage}
        </span>
      )}
    </div>
  );
}

TemplateSubjectInput.displayName = "TemplateSubject";

export default forwardRef(TemplateSubjectInput);
